import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMobile
    ? _c(
        VBottomSheet,
        {
          attrs: { "data-qa": "service-details-modal", scrollable: "" },
          model: {
            value: _setup.isVisible,
            callback: function ($$v) {
              _setup.isVisible = $$v
            },
            expression: "isVisible",
          },
        },
        [
          _c(VCard, { attrs: { tile: "" } }, [
            _c("div", { staticClass: "elevation-4 px-4 pb-4 pt-6" }, [
              _setup.title
                ? _c(
                    "div",
                    {
                      staticClass: "text-h6 text--text",
                      class: { "mb-2": _vm.isDoctorWorkAtLpu },
                    },
                    [_vm._v("\n        " + _vm._s(_setup.title) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isDoctorWorkAtLpu
                ? _c(
                    "div",
                    {
                      staticClass: "text-body-2 text-secondary--text",
                      attrs: {
                        "data-qa":
                          "service-details-content_is_doctor_work_at_lpu",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t(
                              "Комплекс услуг указан врачом. Цена может быть не окончательной.",
                              _setup.optionsLang
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-6 px-4 overflow-y-auto" },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "elevation-8 pa-2" },
              [
                _c(
                  VBtn,
                  {
                    staticClass: "primary--text elevation-0 w-100",
                    attrs: { color: "bg-primary" },
                    on: { click: _setup.close },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_setup.t("Понятно", _setup.optionsLang)) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "service-details-modal",
            title: _setup.title,
            "min-height": "100px",
            size: "lg",
            divider: "",
          },
          scopedSlots: _vm._u([
            {
              key: "prependBtn",
              fn: function ({ btnProps }) {
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      { on: { click: _setup.close } },
                      "v-btn",
                      btnProps,
                      false
                    ),
                    [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
                  ),
                ]
              },
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "modal-actions-btn-close",
                        color: "primary",
                        text: "",
                      },
                      on: { click: _setup.close },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.t("Закрыть", _setup.optionsLang)) +
                          "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _setup.isVisible,
            callback: function ($$v) {
              _setup.isVisible = $$v
            },
            expression: "isVisible",
          },
        },
        [
          _vm._v(" "),
          _vm.isDoctorWorkAtLpu
            ? _c(
                "div",
                {
                  staticClass: "text-body-2 text-secondary--text mb-5",
                  attrs: {
                    "data-qa": "service-details-content_is_doctor_work_at_lpu",
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _setup.t(
                          "Комплекс услуг указан врачом. Цена может быть не окончательной.",
                          _setup.optionsLang
                        )
                      ) +
                      "\n  "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }